import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from '../services/env.service';
import { Observable } from 'rxjs';
import { responseData } from 'src/interface/book';

@Injectable({
    providedIn: 'root'
})
export class JournalService {

    apiUrl = "http://localhost/host/rvhost_backend/public/api/";
    journal_displayname: string;
    constructor(private http: HttpClient, private EnvService: EnvService) { }

    // API URL using GET method
    getJournals(queryParams): Observable<responseData> {
        return this.http.get<responseData>(this.EnvService.siteApiUrl + 'web/journals', {
            params: queryParams
        })
    }

}
